import { supabaseClient } from "supabase";

export type QueryUsersParams = {
  name?: string;
  page?: number;
  perPage?: number;
};

export const queryUsers = async ({ name, page, perPage }: QueryUsersParams) => {
  let query = supabaseClient.from("users").select("*", {
    count: "exact",
  });

  if (name) {
    query = query.ilike("name", `%${name}%`);
  }

  query = query.order("name");

  if (page && perPage) {
    query = query.range(
      (page - 1) * perPage,
      (page - 1) * perPage + perPage - 1
    );
  }

  const { data, count, error } = await query;

  if (error) {
    throw error;
  }
  return { users: data || [], count };
};
